"use client";
import React from "react";
import { PageAppointmentSchema } from "@/sanity/pages/PageAppointmentTemplate";
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { CTAButton } from "@/shadcn/ui/button";
import Header from "../global/partials/Header";
import Video from "../global/Video";
import grid from "@/public/global/grid.svg";
import vestraLogo from "@/public/icons/vestra-logo.svg";
import { SanityVideoPlayer } from "../ui/SanityVideoPlayer";
import Footer from "../global/partials/Footer";
import HubspotMeeting from "../global/HubspotMeeting";
import Chip from "../global/ui/Chip";

export default function PageAppointmentJSX({
  data,
}: {
  data: PageAppointmentSchema;
}) {
  return (
    <>
      <section className="relative min-h-screen w-full pb-[23rem] lg:pb-[12.5rem]">
        <Image
          src={grid}
          alt="grid"
          className="absolute z-[0] inset-0 !w-full !h-full object-cover"
        />

        {/* Hero Section */}
        <div className=" relative z-[1]">
          <div className="container mx-auto px-[2rem] pt-[6.5rem]">
            <div className="flex flex-col items-center justify-center text-center">
              <div className="mb-[8rem] w-[min(184rem,100%)] flex items-center justify-between">
                <Image
                  src={vestraLogo}
                  alt="logo"
                  className="!w-[18rem] lg:!w-[20rem]"
                />
                <div className="flex items-center gap-[1.5rem]">
                  {data.headerChip.icon && (
                    <Image
                      src={data.headerChip.icon}
                      alt="logo"
                      className="!w-[3.5rem] lg:!w-[4rem]"
                    />
                  )}
                  <p className="text-black mb-0">
                    {data.headerChip.text ?? ""}
                  </p>
                </div>
              </div>

              {data.heroChip && (
                <Chip text={data.heroChip} className="mb-[2.5rem]" />
              )}
              {/* Hero Title */}
              {data.heroTitle && (
                <div
                  className="mb-[2rem] lg:mb-[5rem] richtext richtext-center prose-h2:text-[4.75rem] lg:prose-h2:text-[7rem] prose-h2:text-[#012234]/90 prose-h2:font-normal prose-h2:w-[min(114rem,100%)]
                  prose-p:text-black/60 prose-p:text-[2rem] lg:prose-p:text-[2.25rem] prose-p:leading-[150%] prose-p:w-[min(85rem,100%)]"
                >
                  <PortableText
                    value={data.heroTitle}
                    components={richTextComponent}
                  />
                </div>
              )}
              <div className="w-[min(108rem,100%)]">
                <HubspotMeeting meetingEmbed={data?.calendarLink} />
              </div>
            </div>
          </div>
        </div>
      </section>
      {data.settings.footer && <Footer data={data.settings.footer} slug={data?.settings?.slug?.current} />}
    </>
  );
}
